// Map of tool names to their pending state messages
export const TOOL_PENDING_MESSAGES: Record<string, string> = {
  browserUse: 'Opening browser…',
  checkCapability: 'Thinking...',
  coverageGapAnalysis: 'Analyzing coverage gaps...',
  dataExplorer: 'Exploring data...',
  image_generation: 'Generating image...',
  web_search: 'Searching the web...',
  processFiles: 'Processing files...',
  emailDraftReview: 'Preparing email draft...',
  summarizeEntities: 'Summarizing...',
  fillSl1Form: 'Filling SL1 form...',
  fillSl2Form: 'Filling SL2 form...',
  formFilling: 'Filling form...',
  pptxRevisor: 'Revising content...',
  documentSearch: 'Searching documents...',
  readFile: 'Reading file...',
  shell: 'Running command...',
  clarification: 'Waiting for details...',
};

/**
 * Helper function to render tool pending state
 */
export function renderToolPendingState(toolName: string): React.ReactNode | null {
  const pendingMessage = TOOL_PENDING_MESSAGES[toolName];
  if (pendingMessage) {
    return <div className="text-muted-foreground px-5">{pendingMessage}</div>;
  }
  return null;
}
